import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Box,
    Avatar
} from "@mui/material";
import { ReactComponent as LockOpenIcon } from "../../../../../Assets/Icons/lockIcon.svg";

interface UnlockConfirmationDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    userName: string | null;
    opportunityId: string;
}

const UnlockConfirmationDialog: React.FC<UnlockConfirmationDialogProps> = (props) => {

    const {
        open,
        onClose,
        onConfirm,
        userName,
        opportunityId
    } = props;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            sx={{
                '& .MuiDialog-paper': {
                    maxWidth: '595px',
                    width: '100%',
                    borderRadius: '10px',
                    paddingBlock: '15px',
                },
            }}
        >
            <Box display="flex" justifyContent="center" mt={"20px"}>
                <Avatar sx={{ bgcolor: "#f0f0f0", width: 70, height: 70,display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <LockOpenIcon />
                </Avatar>
            </Box>

            <DialogTitle sx={{ textAlign: "center", fontWeight: 600, fontSize: "1.25rem" }}>
                Unlock Application?
            </DialogTitle>

            <DialogContent>
                {userName ? (
                    <>
                        <Typography align="center">
                            Are you sure you want to unlock application of <strong>{userName}</strong>?
                        </Typography>
                        <Typography align="center" variant="body2" color="text.secondary" mt={1}>
                            ({opportunityId})
                        </Typography>
                    </>
                ) : (
                    <Typography align="center">
                        Are you sure you want to unlock application with the following Opportunity ID?
                        <br />
                        <Typography align="center" variant="body2" color="text.secondary" mt={1}>
                            {opportunityId}
                        </Typography>
                    </Typography>
                )}
            </DialogContent>

            <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
                <Button variant="outlined" onClick={onClose} color="success" sx={{width:"120px"}}>
                    No
                </Button>
                <Button variant="contained" onClick={onConfirm} color="success" sx={{width:"120px"}}>
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UnlockConfirmationDialog;
